/**
 * HomePage - Generated page component.
 */
import React, { useEffect } from 'react';
import HeroCard from '../components/cards/HeroCard';
import SectionTitleCard from '../components/cards/SectionTitleCard';
import FeatureCard from '../components/cards/FeatureCard';

const HomePage: React.FC = () => {
  useEffect(() => {
    document.title = 'Home | Kuiken Technologies LLC.';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', '');
  }, []);

  return (
    <main>

      <section className="layout-full section-padding" aria-label="HomeHero">

            <HeroCard title={"Creating positive impact through sustainably built solutions"} subtitle={"We help intentional and sustainable organizations ship faster, reduce complexity, and build durable systems—without sacrificing quality. "} image={"https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2400&q=80"} height={460} overlay={true} text_color={"#e9f0ec"} variant={"ImageOverlay"}/>
      </section>
      <section className="layout-container section-padding" aria-label="WhatWeDo">

            <SectionTitleCard title={"What we do"} subtitle={"We partner with leaders and product teams to plan, build, and deliver initiatives that create lasting change. From strategy to execution, we bring structure, velocity, and clarity to a market (and world) of chaos. "}/>
            <FeatureCard columns={3} items={[{"title": "Big Picture", "body": "Clear roadmaps, sustainable solutions, and measurable outcomes."}, {"title": "Execution", "body": "Reliable delivery from an experienced team of multi-disciplinary engineers."}, {"title": "Optimization", "body": "Performance, cost, and process improvements that scale."}]} variant={"MiniGrid"}/>
      </section>
    </main>
  );
};

export default HomePage;
